import { time } from '@/utilities/timeUtils';
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';

import { MinimalEvent } from '@/generated/model/minimalEvent';

import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

export function RouteEventDetail({ events }: { events: MinimalEvent[] | undefined }) {
  if (!events) return null;
  return (
    <>
      <TableContainer component={Paper}>
        <Table className="route-event-detail-table">
          <TableBody>
            {events.map((event) => (
              <TableRow key={event.eventTimeMicros} className="route-event-detail-table-row">
                <TableCell sx={{ width: 60 }}>{time(event.eventTimeMicros)}</TableCell>
                <TableCell sx={{ width: 60 }}>
                  <LocalShippingIcon className="route-event-detail-icon" />
                  {event.marker == 'running' && <DoubleArrowIcon className="route-event-detail-icon" />}
                  {event.marker == 'standing' && <HourglassEmptyIcon className="route-event-detail-icon" />}
                </TableCell>
                <TableCell>
                  <div className="route-event-description">{event.description}</div>
                  <div className="route-under-text-sublabel">#{event.code}</div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
